<template>
  <div>
    <p class="back_box" @click="$router.go(-1)">
			<img src="../../../static/images/back.png" alt=""> 返回上一页
		</p>
    <ParheaderVue :caseid="caseid" :token="token"/>
    <Parinf :caseid="caseid" :token="token" />
    <div class="youze">
      <p><b>保险责任确定</b></p>
      <el-radio v-model="insuranceLiabilityStatus" label="3">有责</el-radio>
      <el-radio v-model="insuranceLiabilityStatus" label="2">无责</el-radio>
    </div>
    <div class="youze">
      <p><b>详细责任描述</b></p>
      <el-input type="textarea" placeholder="请输入内容" v-model="insuranceLiabilityStatement">
      </el-input>
    </div>
    <el-button style="margin: 0 auto;display: block;" type='primary' @click='setZeren'>确定</el-button>
  </div>
</template>
<script>
	import ParheaderVue from "../par/parheader.vue";
	import Parinf from "../par/Parinf.vue";
  import { accessCaseLiability } from '@/views/axios/api'
export default{
  data(){
    return{
      token:JSON.parse(window.localStorage.getItem("data")).data,
      caseid:this.$route.query.caseId || this.$route.query.caseid,
      insuranceLiabilityStatus:'3',
      insuranceLiabilityStatement:''
    }
  },
  components:{
  	ParheaderVue,
  	Parinf
  },
  methods:{
    setZeren(){
      if(!this.insuranceLiabilityStatement) return this.$message.error('责任描述不能为空')
      var data={
          token:this.token,
          id:this.caseid,
          status:this.insuranceLiabilityStatus,
          statement:this.insuranceLiabilityStatement
      }
      accessCaseLiability(data)
      .then(res => {
        console.log(res);
        if(res.data.code == 0){
          this.$message.success('认定成功')
          this.$router.go(-1)
        }
      })
      .catch(err => {
        console.log(err);
      })
    }
  }
}
</script>
<style type="text/css" scoped="scoped">
	.back_box {
		text-align: left;
		font-size: 14px;
		line-height: 45px;
		color: #666;
		cursor: pointer;
	}
  .youze{margin-bottom: 20px;}
  .youze > p{margin-bottom: 10px;}
</style>



// WEBPACK FOOTER //
// src/components/regulator/waitCaseSet.vue